import { render, staticRenderFns } from "./ChatTip.vue?vue&type=template&id=8925f2ee&scoped=true"
import script from "./ChatTip.vue?vue&type=script&lang=js"
export * from "./ChatTip.vue?vue&type=script&lang=js"
import style0 from "./ChatTip.vue?vue&type=style&index=0&id=8925f2ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8925f2ee",
  null
  
)

export default component.exports